import { useState, useEffect, useRef, useCallback } from 'react';
import { getTaskStatus } from '../services/api';

const POLL_INTERVAL = 1500;

export function useTaskPolling(taskId) {
  const [task, setTask] = useState(null);
  const [error, setError] = useState(null);
  const intervalRef = useRef(null);

  const stopPolling = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  useEffect(() => {
    if (!taskId) return;

    setError(null);

    const poll = async () => {
      try {
        const data = await getTaskStatus(taskId);
        setTask(data);
        if (data.status === 'completed' || data.status === 'failed') {
          stopPolling();
        }
      } catch (err) {
        setError(err.message);
        stopPolling();
      }
    };

    poll();
    intervalRef.current = setInterval(poll, POLL_INTERVAL);

    return stopPolling;
  }, [taskId, stopPolling]);

  return { task, error, stopPolling };
}
